import { Icon28Smiles2Outline } from '@vkontakte/icons';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { familyFeaturePreviewAsideTooltip } from 'reactApp/appHelpers/featuresHelpers/features/familyFunctions';
import { useFamilyShowFeaturesHook, useFamilyShowPreviewHook } from 'reactApp/hooks/useFamilyShowHook';
import { getFamilyLoadingState } from 'reactApp/modules/family/family.selectors';
import { changeFamilyContentCategory } from 'reactApp/modules/familyContent/familyContent.module';
import { getFamilyContentCategories } from 'reactApp/modules/familyContent/familyContent.selectors';
import { FamilyContentCategoryType } from 'reactApp/modules/familyContent/familyContent.types';
import { historyPush } from 'reactApp/modules/router/router.module';
import { FamilyContentPage } from 'reactApp/sections/FamilyContentPage/FamilyContentPage';
import { FamilyPreviewPage } from 'reactApp/sections/FamilyPreviewPage/FamilyPreviewPage';
import { BreadcrumbsContainer } from 'reactApp/ui/BreadcrumbsContainer/BreadcrumbsContainer';
import { EInformerColor } from 'reactApp/ui/Informer/Informer.types';
import { InlineInformer } from 'reactApp/ui/Informer/InlineInformer/InlineInformer';
import { PageTabMenu } from 'reactApp/ui/PageTabMenu/PageTabMenu';
import { sendDwh } from 'reactApp/utils/ga';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import { setShowFamilyPageOrAlbums } from '../AlbumsPage/CustomAlbumsPage.helpers';
import styles from './FamilyPageWrapper.css';

export const FamilyPageWrapper: React.FC<{ type: FamilyContentCategoryType }> = ({ type }) => {
    const dispatch = useDispatch();

    const { isLoaded: isFamilyLoaded } = useSelector(getFamilyLoadingState);

    const categories = useSelector(getFamilyContentCategories);
    const currentCategory: FamilyContentCategoryType = (type && FamilyContentCategoryType[type]) || FamilyContentCategoryType.folders;

    const showFeature = useFamilyShowFeaturesHook();
    const showProductPay = useFamilyShowPreviewHook();

    useEffect(() => {
        sendDwh({
            eventCategory: ECategoryGa.entered,
            action: 'section',
            dwhData: {
                section: 'family',
            },
        });
        if (familyFeaturePreviewAsideTooltip) {
            dispatch(setShowFamilyPageOrAlbums());
        }
    }, []);

    const handleChangeCategory = useCallback(
        (category) => {
            const targetCategory = FamilyContentCategoryType[category];
            if (targetCategory === currentCategory) {
                return;
            }

            sendPaymentGa({ eventCategory: 'family_section_click_tab', to: targetCategory, from: currentCategory });
            dispatch(changeFamilyContentCategory({ category: targetCategory }));
            dispatch(historyPush({ id: `/family/${targetCategory}` }));
        },
        [dispatch, currentCategory]
    );

    if (isFamilyLoaded && !showFeature && !showProductPay) {
        return <Navigate replace to="/home/" />;
    }

    return (
        <div className={styles.root} data-qa-id="family-content-page">
            <div className={styles.header} data-qa-id="family-header">
                <div className={styles.titleBlock} data-qa-id="family-title">
                    <BreadcrumbsContainer />
                    <InlineInformer color={EInformerColor.newTransparent} className={styles.inlineFormer}>
                        <Icon28Smiles2Outline className={styles.icon} width={20} height={20} /> Файлы в этом разделе доступны всем
                        участникам подписки
                    </InlineInformer>
                </div>
                <div className={styles.menu} data-qa-id="family-menu">
                    <PageTabMenu current={currentCategory} tabs={categories} onClick={handleChangeCategory} />
                </div>
            </div>
            {showProductPay ? (
                <FamilyPreviewPage type={currentCategory} paySource={`family-preview-${currentCategory}`} />
            ) : (
                <FamilyContentPage type={currentCategory} />
            )}
        </div>
    );
};
